export default {
  uiv: {
    datePicker: {
      clear: 'クリア',
      today: '今日',
      month: '月',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      year: '年',
      week1: '月曜日',
      week2: '火曜日',
      week3: '水曜日',
      week4: '木曜日',
      week5: '金曜日',
      week6: '土曜日',
      week7: '日曜日',
    },
    timePicker: {
      am: '午前',
      pm: '午後',
    },
    modal: {
      cancel: 'キャンセル',
      ok: 'OK',
    },
  },
};
